import * as colors from './colors'

const styles = {
    content: {
        fontFamily: 'Roboto',
        fontSize: '8px',
    },

    details: {
        bottom: 0,
        position: 'absolute',
        right: 0,
    },

    detailsButton: {
        backgroundColor: 'transparent',
        border: '0',
        color: 'blue',
        cursor: 'pointer',
        fontFamily: 'Roboto Condensed',
        margin: '2px',
        padding: '2px',
        textDecoration: 'underline',
    },

    marginLeftButton: {
        marginLeft: '10px',
    },

    closeButton: {
        backgroundColor: 'transparent',
        border: 0,
        height: '10px',
        position: 'absolute',
        top: 0,
        right: '2px',
        zIndex: 2,
        marginTop: '1px',
        marginRight: '1px',
        color: 'gray',

    },
    title: {
        width: '100%',
        height: '14px',
        color: 'black',
        fontFamily: 'Roboto Condensed',
        fontSize: '16px',
        marginTop: '6px',
        paddingLeft: '8px',
        zIndex: 1,
    },

    frameContainer: {
        fontFamily: 'Roboto',
        position: 'absolute',
        top: 0,
        textAlign: 'center',
        zIndex: 100,
        gridColumnStart: 'main',
        gridColumnEnd: 'toolbar',
        gridRowStart: 'subheader',
        gridRowEnd: 'bottom',
        width: '100%',
    },
}

export const sliderStyle = {
    dotStyle: { borderColor: colors.secondaryTwo },
    handleStyle: { borderColor: colors.secondaryTwo },
    trackStyle: [{ backgroundColor: colors.secondaryTwo }],
}

export default styles
